import { render, staticRenderFns } from "./NewEditExpoCommodities.vue?vue&type=template&id=deb87afa&"
import script from "./NewEditExpoCommodities.vue?vue&type=script&lang=js&"
export * from "./NewEditExpoCommodities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports